export default __webpack_public_path__ + "static/media/kraver.b77fd1a8.svg";